<template>
  <div
    :class="bgClass"
    class="tw-relative tw-w-full md:tw-h-screen tw-bg-no-repeat tw-bg-cover tw-overflow-hidden tw-pb-4"
  >
    <!-- preload map section image  -->
    <div class="tw-bg-map-section-02 tw-hidden"></div>
    <div class="tw-bg-map-section-03 tw-hidden"></div>

    <div
      class="tw-w-full tw-h-1.5/10 tw-hidden md:tw-block xl:tw-h-1/10 lg:tw-h-1.5/10"
    ></div>
    <div class="tw-flex tw-flex-col md:tw-flex-row">
      <div class="tw-w-full tw-mt-8 tw-h-2/10 md:tw-w-2/12 md:tw-h-full">
        <div class="md:tw-h-1/6 tw-flex tw-items-end">
          <section-tag tag-name="map" :tag-number="slidePage" />
        </div>
      </div>
      <!-- <div class="tw-absolute tw-top-0 tw-w-full tw-h-32 tw-bg-white"></div> -->
      <div
        class="tw-w-full tw-mt-9 tw-px-4 md:tw-mt-0 md:tw-px-0 md:tw-w-10/12 tw-h-full"
      >
        <div class="slide-cont tw-flex tw-flex-row">
          <div class="carousel-wrapper tw-w-full" v-if="!mobile">
            <VueSlickCarousel
              v-bind="settings"
              @beforeChange="beforeChangeCarousel"
            >
              <div v-for="(map, mapIndex) in mapData" :key="mapIndex">
                <div
                  class="row1 tw-flex tw-flex-col md:tw-items-start md:tw-flex-row"
                >
                  <div class="tw-flex tw-flex-col tw-w-full md:tw-w-3/12">
                    <span
                      v-animate="{ value: 'fadeInUp', delay: 300 }"
                      class="tw-max-w-max tw-flex tw-items-center tw-justify-center tw-bg-bright-violet tw-text-white tw-px-4 tw-uppercase tw-rounded-2xl tw-box-content tw-text-1.6 2xl:tw-text-1.9 md:tw-text-1.5 tw-font-sans tw-font-bold"
                      v-html="map.type"
                    ></span>
                    <span
                      v-animate="{ value: 'fadeInUp', delay: 600 }"
                      class="xl:tw-mt-2 lg:tw-mt-5 tw-font-caslon tw-text-5.4 xl:tw-text-8.8 md:tw-text-4.4 tw-text-white tw-tracking-wide tw-leading-none tw-uppercase"
                      v-html="map.name"
                    ></span>
                  </div>
                  <div
                    class="tw-w-full 2xl:tw-w-5/12 xl:tw-w-6/12 lg:tw-w-6/12 xl:tw-ml-0 lg:tw-ml-5"
                    v-animate="{ value: 'fadeInUp', delay: 900 }"
                  >
                    <img :src="`${imgPath}${map.imgUrl}`" />
                  </div>
                </div>

                <div class="row2 tw-flex tw-flex-row tw-mt-12">
                  <div class="tw-flex tw-flex-col tw-w-3/12"></div>
                  <div
                    class="tw-w-8/12 tw-flex tw-flex-row xl:tw-ml-0 lg:tw-ml-5"
                  >
                    <div
                      v-animate="{ value: 'fadeInUp', delay: 1200 }"
                      class="tw-flex tw-flex-col tw-w-1/2 last:tw-ml-5"
                      v-for="(desc, dkIndex) in map.desc"
                      :key="dkIndex"
                    >
                      <div
                        class="tw-flex tw-flex-row tw-items-start tw-justify-start tw-h-14"
                      >
                        <span
                          class="tw-flex tw-items-center tw-justify-center tw-uppercase tw-bg-soft-blue tw-text-white tw-py-1 tw-px-2 tw-mr-2 xl:tw-text-1.8 lg:tw-text-2xl tw-font-sans tw-font-medium"
                        >
                          part {{ dkIndex + 1 }}
                        </span>
                        <span
                          class="2xl:tw-w-4/5 xl:tw-w-4/6 lg:tw-w-9/12 tw-inline-block tw-text-white 2xl:tw-text-4xl xl:tw-text-3xl lg:tw-text-1.5 tw-font-bold"
                          v-html="desc.title"
                        >
                        </span>
                      </div>
                      <p
                        class="2xl:tw-mt-12 xl:tw-mt-20 xl:tw-overflow-y-hidden xl:tw-h-full lg:tw-mt-16 2xl:tw-text-3xl lg:tw-text-2xl lg:tw-overflow-y-scroll lg:tw-h-260 tw-text-white "
                        v-html="desc.text"
                      ></p>
                    </div>
                  </div>
                </div>
              </div>
              <template #customPaging="page">
                <div
                  class="dots-wrapper custom-dot tw-relative tw-flex tw-flex-row tw-items-center tw-justify-center"
                  v-animate="{ value: 'fadeInUp', delay: 1500 }"
                >
                  <span
                    class="line tw-absolute tw-w-0.5 tw-h-12 tw-bg-white tw-top-0 tw-left-1.1/10"
                  ></span>
                  <span
                    class="tw-font-medium number tw-w-5 tw-text-white xl:tw-text-3xl lg:tw-text-2xl"
                    >{{ mapData[page].id }}</span
                  >
                  <span
                    class="dot tw-block tw-z-20 tw-rounded-full tw-w-2 tw-h-2 tw-bg-white tw-ml-5 tw-mr-5"
                  ></span>
                  <span
                    class="name tw-w-full tw-text-white tw-uppercase xl:tw-text-3xl lg:tw-text-2xl tw-font-medium"
                    >{{ mapData[page].name }}</span
                  >
                </div>
              </template>
            </VueSlickCarousel>
          </div>

          <!-- mobile -->
          <div class="carousel-wrapper tw-w-full" v-if="mobile">
            <VueSlickCarousel v-bind="settings">
              <div v-for="(map, mapIndex) in mapData" :key="map.id">
                <div
                  class="row1 tw-flex tw-flex-col tw-items-center md:tw-flex-row"
                >
                  <div class="tw-flex tw-flex-col tw-w-full md:tw-w-3/12">
                    <span
                      class="tw-max-w-max tw-flex tw-items-center tw-justify-center tw-bg-bright-violet tw-text-white tw-px-4 tw-uppercase tw-rounded-2xl tw-box-content tw-text-1.6 tw-font-medium"
                      v-html="map.type"
                    ></span>
                    <span
                      class="tw-font-caslon tw-text-4.4 tw-text-white tw-tracking-wide tw-leading-none tw-uppercase tw-mt-4 tw-font-bold"
                      v-html="map.name"
                    ></span>
                  </div>
                  <div class="tw-w-full">
                    <img :src="`${imgPath}${map.imgUrl}`" />
                  </div>
                </div>
                <div
                  class="part-btn-cont tw-max-w-full tw-flex tw-justify-between tw-mt-6"
                >
                  <div
                    :class="desc.isActive ? 'part-btn-active' : 'part-btn'"
                    v-for="(desc, buttonIndex) in map.desc"
                    :key="desc.text"
                    class="tw-font-medium tw-uppercase tw-text-1.8 tw-w-72 tw-flex tw-items-center tw-justify-center tw-py-2 border tw-border-2 tw-bg-opacity-30 tw-bg-gray-900 tw-text-white fisrt:tw-mr-2 last:tw-ml-2"
                    @click="handlePartDesc(mapIndex, buttonIndex)"
                  >
                    part {{ buttonIndex + 1 }}
                  </div>
                </div>
                <div
                  class="tw-mt-6 tw-bg-black tw-bg-opacity-30 tw-p-6 tw-h-400"
                >
                  <div v-for="(desc, descIndex) in map.desc" :key="descIndex">
                    <div
                      v-if="desc.isActive"
                      class="tw-w-full tw-flex tw-flex-col tw-justify-center tw-items-start"
                    >
                      <span
                        class="tw-w-28 tw-flex tw-items-center tw-justify-center tw-uppercase tw-bg-soft-blue tw-text-white tw-py-1 tw-px-3 tw-text-1.4"
                        >part {{ descIndex + 1 }}</span
                      >
                      <span
                        class="tw-text-white tw-text-1.8 tw-mt-4 tw-font-bold"
                        v-html="desc.title"
                      ></span>
                      <p
                        class="tw-relative tw-text-white tw-text-1.2 tw-overflow-y-auto tw-mt-4 tw-h-96"
                        v-html="desc.text"
                      ></p>
                    </div>
                  </div>
                </div>
              </div>
            </VueSlickCarousel>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import SectionTag from "../components/SectionTag.vue";
export default {
  name: "map-section",
  components: { VueSlickCarousel, SectionTag },
  props: {
    mobile: Boolean
  },
  data: function() {
    return {
      bgClass: "tw-bg-map-section-01",
      slidePage: "01",
      settings: {
        dots: true,
        arrows: false,
        fade: true,
        autoplay: false,
        responsive: [
          {
            breakpoint: 1025,
            settings: {
              fade: false
            }
          },
          {
            breakpoint: 640,
            settings: {
              dots: false,
              fade: false
            }
          }
        ]
      },
      imgPath: process.env.VUE_APP_IMG_URL,
      mapData: [
        {
          type: "field",
          imgUrl: "/map-01.jpg",
          id: "01",
          name: "zisk plains",
          desc: [
            {
              isActive: true,
              title:
                "The plains ruled by Zisks, the nobles of the Kingdom of Howl",
              text:
                "Since ancient times, Eastland has had a history of struggle and rebellion. The reason why such a continent has become somewhat stable was because there was a Howl Kingdom that established a site at the center of the continent and developed. The first king of Howl followed the message of a spirit seeking harmony and stability, and along with his own beliefs, he carried out politics based on his national ideology. Thanks to him, the continent has spent a long time without any problems.<br/><br/>In the Howl Kingdom, there was a plain ruled by various nobles, and the most recognized one was the Zisk Plains in the south. The land was ruled for a long time by a noble of a family named Zisk. It was also an area where many forces wanted to invade because it was full of resources.<br/><br/>Still, Zisk family had firmly kept the land protected by their ancestors, and believed that their descendants would stay there forever and continue their will. However, it was destroyed by some forces that tried to be absolute evil."
            },
            {
              isActive: false,
              title: "A forgotten land",
              text:
                "As time went by, people got unfamiliar with the Zisk Plains. No one needed to know except for Ziskad, who was the only survivor.<br/><br/>Then one day, Ziskad hears the news of the Zisk Plains. That all soldiers of Deimos who decided to stay where old Zisk Plains was have disappeared. Ziskad, who cannot not go there because of a trauma, is trying to ask others to check the situation. Sadly, no one wants to go there because of a rumor...<br/><br/>According to the rumor, those who came back from Zisk Plains are suffering from seeing unknown beings. Because of things like that, the Zisk Plains became an ominous place where everyone does not want to visit, which turned it into a forgotten place."
            }
          ]
        },
        {
          type: "2-man instance dungeon",
          imgUrl: "/map-02.jpg",
          name: "VOID STAR",
          id: "02",
          desc: [
            {
              isActive: true,
              title: "A void space caused by the giant meteorite",
              text:
                "A huge star that fell from the sky filled the ground with flames. A huge star is revealed behind the flames, which could only be stopped after all life on the ground has been extinguished. It was a mysterious star that looked lonely.<br/><br/>After looking at it for a long time, people called this mysterious and lonely feeling 'void'. Therefore, people named it the 'Void Star'.<br/><br/>The star, which was neither negative nor positive, soon became a symbol and center of the Zisk Plains, and the meteoric irons found near and inside the meteorite were used to make special weapons and equipment.<br/><br/>Thus, the Zisk Plains was able to develop by making its name known as the production site of extraordinary metallurgy."
            },
            {
              isActive: false,
              title: "The last star on earth",
              text:
                "After the Dark War, the Howl Kingdom has fallen, and the Zisk Plains has been taken over by Deimos. The members of Deimos began to collect meteoric irons in the Void Star to make weapons, just as the residents of the Zisk Plains did.<br/><br/>As time went by, traces of those collecting meteoric irons disappeared. Even the soldiers retreated. The Union of Lights felt suspicious of their movements and launched an investigation, but could not find anything strange.<br/><br/>One day, strange rumors began to circulate...<br/><br/>Strange beings have been found in the Void Star... Beings that seem to be from a different world... They are kidnapping anyone they see that is approaching the star, torturing them with fear..."
            }
          ]
        },
        {
          type: "6-man instance dungeon",
          imgUrl: "/map-03.jpg",
          name: "OBLIVION LAKE",
          id: "03",
          desc: [
            {
              isActive: true,
              title: "A gloomy lake that tells the truth",
              text:
                "For a long time, a strange rumor has been told about the lake near the Zisk Plains. It is said that if a person who wants to find the truth goes to the lake and endure a certain ordeal, it will tell the truth. Those who believed the rumor went to the lake and begged, but there was no way to know the truth.<br/><br/>Those who could not solve the ordeal jumped into the lake and died, and even if they got revived, they forgot the truth they wanted to know..."
            },
            {
              isActive: false,
              title: "A place where the truth is buried",
              text:
                "It is said that many ominous rumors came in as the soldiers of the Deimos occupied the plains.<br/><br/>There was one unusual rumor... It is said that a huge flame was burning in the center of the lake. The flame was about to burn all the nearby areas.<br/><br/>No one knows who caused the flame, but there was one thing for sure... No one could get to the lake and the truth of the flames..."
            }
          ]
        }
      ]
    };
  },
  methods: {
    beforeChangeCarousel: function(oldIndex, newIndex) {
      //console.log(newIndex);
      let number = newIndex + 1;
      this.slidePage = `0${number}`;
      if (newIndex === 0) {
        this.bgClass = "tw-bg-map-section-01";
      }
      if (newIndex === 1) {
        this.bgClass = "tw-bg-map-section-02";
      }
      if (newIndex === 2) {
        this.bgClass = "tw-bg-map-section-03";
      }
    },
    handlePartDesc: function(mIndex, dIndex) {
      console.log(mIndex, dIndex);
      for (let i = 0; i < this.mapData[mIndex].desc.length; i++) {
        console.log("handlePartDesc");
        if (dIndex === i) {
          this.mapData[mIndex].desc[i].isActive = true;
        } else {
          this.mapData[mIndex].desc[i].isActive = false;
        }
      }
    }
  }
};
</script>

<style lang="postcss" scoped>
.carousel-wrapper >>> .slick-dots {
  @apply tw-w-96 tw-flex tw-flex-col tw-top-1/4 xl:tw-mt-16 lg:tw-mt-20 !important;
}
.carousel-wrapper >>> .slick-dots li {
  @apply tw-w-full tw-mt-4 tw-text-left;
}
.carousel-wrapper >>> .slick-dots .slick-active .dots-wrapper .number {
  @apply tw-text-dot-yellow;
}
.carousel-wrapper >>> .slick-dots .slick-active .dots-wrapper .dot {
  @apply tw-bg-dot-yellow;
}
.carousel-wrapper >>> .slick-dots .slick-active .dots-wrapper .name {
  @apply tw-text-dot-yellow;
}
.carousel-wrapper >>> .part-btn-cont .part-btn {
  @apply tw-border-soft-blue;
}
.carousel-wrapper >>> .part-btn-cont .part-btn-active {
  @apply tw-border-white tw-shadow-dots-active;
}
</style>
